/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
 */
export interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    first_name: string;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    last_name: string;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    npi: string | null;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    credential?: string | null;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    address_line?: string | null;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    city?: string | null;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    state?: string | null;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner
     */
    zip?: string | null;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "npi" in value;

    return isInstance;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'npi': json['npi'],
        'credential': !exists(json, 'credential') ? undefined : json['credential'],
        'address_line': !exists(json, 'address_line') ? undefined : json['address_line'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSON(value?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'npi': value.npi,
        'credential': value.credential,
        'address_line': value.address_line,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
    };
}
